import React, { Component } from "react";
import { NavLink } from "react-router-dom";
import styled from "styled-components";

import Card from "../../common/components/Card";
import List from "../../common/components/List";
import { media } from "../../../utils/uiSizes";
import ScoreCard from "../../common/components/ScoreCard";

const StyledList = styled(List)`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;

  > * {
    width: 100%;
    ${media.tablet`
  	  width: calc(50% - 0.625rem);
    `} margin-bottom: 1.25rem;
  }
`;

class FeaturedContentList extends Component {
  renderCard = item => {
    const { type } = this.props;
    const { _id, imageUrl, name, category, tags } = item;
    const urlName = name ? name.toLowerCase()
                        .replace(/ä/g,'a')
                        .replace(/ö/g,'o')
                        .replace(/[^a-zA-Z0-9]/g, '-')
                        .replace(/[-]+/g, '-')
                        .replace(/[-]+$/g, '')
                        :
                        'tuntematonartikkeli'
    const link = item.type === "score" ? "/prizes" : `/${type}/${encodeURI(urlName)}/${_id}`;

    return (
      <NavLink to={link} key={_id}>
        {item.type === "score" && <ScoreCard score={item.score} />}
        {item.type !== "score" && (
          <Card
            key={_id}
            background={imageUrl}
            subTitle={category}
            title={name}
            tags={tags}
            type={item.type}
          />
        )}
      </NavLink>
    );
  };

  render() {
    const { items } = this.props;
    return <StyledList items={items} renderItem={this.renderCard} />;
  }
}

export default FeaturedContentList;



// WEBPACK FOOTER //
// ./src/modules/content/components/FeaturedContentList.js